export default __webpack_public_path__ + "static/media/1.d23882b2.png";